/* eslint-disable */
import styles from './index.module.scss'
import Useful from '../../components/pages/useful'
import translate from '../../utils/translate.json'
import { PageContext } from '../../context/PageContextProvider'
import { useState, useContext, useEffect } from 'react'
import { Book } from '../../icons'
import { LangArrows } from '../../icons'
import { Swiper, SwiperSlide } from 'swiper/react'
import Subscribe from '../../components/pages/subscribe'
import { MagazineCard } from '../../components/core/cards'
import PagesAPI from '../../api/pages'
import Loading from '../../components/pages/loading'
import img from '../../assets/images/book.png'
import 'swiper/css'
import './styles.css'

const Library = ({ className }) => {
  const { language } = useContext(PageContext)
  const [load, setLoad] = useState(false)
  const [info, setInfo] = useState([])
  useEffect(() => {
    (async () => {

    const data1 = await PagesAPI.getMagazinePageInfo()
    await setInfo(data1.data)
    await setLoad(true)
  
    })();
  }, [])
  const [filter, setFilter] = useState(translate.sort?.[language] || '')
  const [date, setDate] = useState(translate.by_date?.[language] || '')
  const [category, setCategory] = useState(translate.category?.[language] || '')
  const [subcategory, setSubcategory] = useState(
    translate.subcategory?.[language] || '',
  )
  const [isVisible1, setIsVisible1] = useState(false)
  const [isVisible2, setIsVisible2] = useState(false)
  const [isVisible3, setIsVisible3] = useState(false)
  const [isVisible4, setIsVisible4] = useState(false)
  const selects = [
    {
      current: filter,
      menu: ['Oldest to newest', 'newest to oldest'],
    },
    {
      current: category,
      menu: ['category1', 'category2', 'category3'],
    },
    {
      current: subcategory,
      menu: ['Subcategory1', 'Subcategory2', 'Subcategory3'],
    },
    {
      current: date,
      menu: ['date1', 'date2', 'date3'],
    },
  ]
  const data = [
    {
      id: 1,
      image: img,
      title: 'Investment Strategy',
      label: 'Top seller',
    },
    {
      id: 2,
      image: img,
      label: 'Top seller',
      title: 'Investment Strategy',
      label: 'Top seller',
    },
    {
      id: 3,
      image: img,
      title: 'Investment Strategy',
      label: 'Top seller',
    },
    {
      id: 4,
      image: img,
      title: 'Investment Strategy',
      label: 'Top seller',
    },
  ]
  const data2 = [
    {
      id: 1,
      image: img,
      title: 'Investment Strategy',
      label: 'New',
    },
    {
      id: 2,
      image: img,
      title: 'Investment Strategy',
    },
    {
      id: 3,
      image: img,
      title: 'Investment Strategy',
    },
    {
      id: 4,
      image: img,
      title: 'Investment Strategy',
    },
  ]
  return load ? (
    <section className={`${styles.container} ${className}`}>
      <Useful />
      <div className={styles.selects}>
        <div
          className={styles.select}
          onBlur={() =>
            setTimeout(function () {
              setIsVisible1(false)
            }, 250)
          }
        >
          <span tabIndex="1" onClick={() => setIsVisible1(true)}>
            {selects[0].current} <LangArrows />
          </span>
          <ul style={isVisible1 ? { display: 'block' } : { display: 'none' }}>
            {selects[0].menu.map((e) => (
              <li
                onClick={() => {
                  setFilter(e)
                }}
              >
                {e}
              </li>
            ))}
          </ul>
        </div>
        <div
          className={styles.select}
          onBlur={() =>
            setTimeout(function () {
              setIsVisible3(false)
            }, 250)
          }
        >
          <span tabIndex="1" onClick={() => setIsVisible3(true)}>
            {selects[1].current} <LangArrows />
          </span>
          <ul style={isVisible3 ? { display: 'block' } : { display: 'none' }}>
            {selects[1].menu.map((e) => (
              <li
                onClick={() => {
                  setCategory(e)
                }}
              >
                {e}
              </li>
            ))}
          </ul>
        </div>
        <div
          className={styles.select}
          onBlur={() =>
            setTimeout(function () {
              setIsVisible4(false)
            }, 250)
          }
        >
          <span tabIndex="1" onClick={() => setIsVisible4(true)}>
            {selects[2].current} <LangArrows />
          </span>
          <ul style={isVisible4 ? { display: 'block' } : { display: 'none' }}>
            {selects[2].menu.map((e) => (
              <li
                onClick={() => {
                  setSubcategory(e)
                }}
              >
                {e}
              </li>
            ))}
          </ul>
        </div>
        <div
          className={styles.select}
          onBlur={() =>
            setTimeout(function () {
              setIsVisible2(false)
            }, 250)
          }
        >
          <span tabIndex="1" onClick={() => setIsVisible2(true)}>
            {selects[3].current} <LangArrows />
          </span>
          <ul style={isVisible2 ? { display: 'block' } : { display: 'none' }}>
            {selects[3].menu.map((e) => (
              <li
                onClick={() => {
                  setDate(e)
                }}
              >
                {e}
              </li>
            ))}
          </ul>
        </div>
      </div>
      <h2>
        <Book />
        {translate.top_seller[language]}
      </h2>
      <Swiper slidesPerView={'auto'} spaceBetween={32} className="book-swiper">
        {data.map((item) => (
          <SwiperSlide key={item.id}>
            <MagazineCard
              img={item.image}
              title={item.title}
              label={item.label}
              to={`/book/${item.id}`}
            />
          </SwiperSlide>
        ))}
      </Swiper>
      <h2>
        <Book />
        {translate.other[language]}
      </h2>
      <Swiper slidesPerView={'auto'} spaceBetween={32} className="book-swiper">
        {data2.map((item) => (
          <SwiperSlide key={item.id}>
            <MagazineCard
              img={item.image}
              title={item.title}
              label={item.label}
              to={`/book/${item.id}`}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  ) : (
    <Loading />
  )
}

export default Library
